module.exports = __webpack_public_path__ + "img/7.1a1f8fe7.png";